import { __assign } from "tslib";
import { isTransparent } from '@wix/shoutout-email-model-v3';
import { defaultBackgroundColor } from '../defaults';
import { toRgbAsHex } from '../color';
import { extractTextStyles } from './extract-text-styles';
export function calcBackgroundColor(color) {
    if (isTransparent(color)) {
        return 'transparent';
    }
    return toRgbAsHex(color);
}
export var getSecondaryButton = function (globalStyles, localStyles, text, href) {
    var fallbackButtonStyles = globalStyles['so-global-b2'];
    var buttonBorderWidth = localStyles.borderWidth || fallbackButtonStyles.borderWidth || '0px';
    var buttonBorderColor = localStyles.borderColor || fallbackButtonStyles.borderColor || '#000';
    return __assign(__assign({}, extractTextStyles(localStyles, fallbackButtonStyles)), { backgroundColor: calcBackgroundColor(localStyles.background ||
            fallbackButtonStyles.backgroundColor ||
            defaultBackgroundColor), border: "solid " + buttonBorderWidth + " " + buttonBorderColor, borderRadius: fallbackButtonStyles.borderRadius || 'Opx', href: href, text: text });
};
//# sourceMappingURL=get-secondary-button.js.map